import { FC } from 'react';
import { Nullable } from 'common-types';
import {
  NotificationChannelType,
  NotificationSettings,
  Recipient,
} from '../types/notification-settings-types';
import EmailNotificationSettings from './EmailNotificationSettings';

const NotificationSettingsSwitcher: FC<
  React.PropsWithChildren<NotificationSettingsSwitcherProps>
> = props => {
  const { isUserAdminRole, notification, potentialRecipients, orgDisplayName } =
    props;

  switch (notification.notificationChannelType) {
    case NotificationChannelType.Email:
      return (
        <EmailNotificationSettings
          notification={notification}
          isUserAdminRole={isUserAdminRole}
          potentialRecipients={potentialRecipients}
          orgDisplayName={orgDisplayName}
        />
      );

    default:
      return null;
  }
};

export interface NotificationSettingsSwitcherProps {
  isUserAdminRole: boolean;
  notification: NotificationSettings;
  potentialRecipients: Nullable<Recipient[]>;
  orgDisplayName: string;
}

export default NotificationSettingsSwitcher;
